export interface AddOn {
  id: string;
  name: string;
  description: string;
  numberOfEntries?: number;
  daysToExpire?: number;
}

export function toAddOn(data: any): AddOn {
  return {
    id: data.id,
    name: data.name,
    description: data.description,
    numberOfEntries: data.number_of_entries,
    daysToExpire: data.days_to_expire,
  };
}
